// extracted by mini-css-extract-plugin
export default {"OurServicesCard_container":"OurServicesCard_OurServicesCard_container__-4kM0"};